module.exports = __webpack_public_path__ + "assets/img/113.cc45495a.jpg";